import { skipToken, useQuery } from '@tanstack/react-query';

import type { BoostMultiplier } from '@/models/campaign';
import type { Promotion } from '@/models/promotion';
import { http } from '@/utils/http';

async function getBoostMultipliers() {
  const { data } = await http.get<BoostMultiplier[]>(
    '/promotions/boost_multipliers',
  );

  return data;
}

export function useBoostMultipliers() {
  return useQuery({
    queryFn: getBoostMultipliers,
    queryKey: ['boost-multipliers'],
  });
}

async function getPromotion(id: number) {
  const { data } = await http.get<Promotion>(`/promotions/${id}`);

  return data;
}

export function usePromotion(id: number | undefined) {
  return useQuery({
    queryFn: id ? () => getPromotion(id) : skipToken,
    queryKey: ['promotions', 'details', id],
  });
}
